import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Filter from '../../Filter';
import Table from '../../Table';
import Pagination from '../../TablePagination';
import LimitButton from '../../LimitSelectBox';
import DoorlockUninstall from './DoorlockUninstall';
import { doorlockTypeFormatter, doorlockStatusFormatter, doorlockBatteryFormatter, dateFormatter } from '../../../lib/formatter';
import doorlockFormatter from './DoorlockFormatter';

const DoorlockList = ({
  doorlockListTotal,
  doorlockListItems,
  buildingListItems,
  floorListItems,
  filterItem,
  sortItem,
  paginationItem,
  currentPageNumber,
  doorlockDeletable,
  listDoorlockApi,
  setFilterItem,
  setSortItem,
  setPaginationItem,
  setCurrentPageNumber,
  history,
}) => {
  const [ isOpenDoorlockUninstallModal, setIsOpenDoorlockUninstallModal ] = useState(false);
  const [ selectedDoorlockId, setSelectedDoorlockId ] = useState('');
  const [ selectedDoorlockName, setSelectedDoorlockName ] = useState('');
  const { t } = useTranslation();

  const statusItems = [
    { key: t('data.doorlock_status.created'), value: 'created' },
    { key: t('data.doorlock_status.installed'), value: 'installed' },
  ];

  const doorlockTypeItems = [
    { key: t('data.doorlock_type.room'), value: 'room' },
    { key: t('data.doorlock_type.commonroom'), value: 'commonroom' },
    { key: t('data.doorlock_type.building'), value: 'building' },
    { key: t('data.doorlock_type.floor'), value: 'floor' },
    { key: t('data.doorlock_type.elevator'), value: 'elevator' },
    { key: t('data.doorlock_type.keytag'), value: 'keytag' },
  ];

  const changePagination = (pageNumber) => {
    setCurrentPageNumber(pageNumber);
    setPaginationItem({
      ...paginationItem,
      offset: (pageNumber - 1) * paginationItem.limit,
    });
  };

  const changeLimit = (limit) => {
    setCurrentPageNumber(1);
    setPaginationItem({
      offset: 0,
      limit,
    });
  };

  const changeSort = (sort) => {
    if (sortItem.sort === sort) {
      setSortItem({
        ...sortItem,
        order: sortItem.order === 'desc' ? 'asc':'desc',
      });
    } else {
      setSortItem({
        sort,
        order: 'desc',
      });
    }
  };

  //디바운싱 사용 구분을 위해 debounce props 추가
  const changeFilterItem = (targetItem, debounce) => {
    if (Object.keys(targetItem).includes('buildingId')) {
      setFilterItem({
        ...filterItem,
        buildingId: targetItem.buildingId,
        floorId: '',
      }, debounce);
    } else {
      setFilterItem({
        ...filterItem,
        ...targetItem,
      }, debounce);
    }
    setCurrentPageNumber(1);
    setPaginationItem({
      ...paginationItem,
      offset: 0,
    });
  };

  const initFilterItem = () => {
    setFilterItem({
      buildingId: '',
      floorId: '',
      name: '',
      serial: '',
      type: '',
      status: '',
      fwType: '',
      fwVersion: '',
    });
    setCurrentPageNumber(1);
    setPaginationItem({
      ...paginationItem,
      offset: 0,
    });
  };

   const selectDoorlockUninstall = (doorlockId, status, doorlockName) => {
     if (status !== 'installed' || !doorlockDeletable) return;
     setSelectedDoorlockId(doorlockId);
     setSelectedDoorlockName(doorlockName);
     setIsOpenDoorlockUninstallModal(true);
   }

  return (
    <Fragment>
      <div className='content-title2'>
        <h3>{t('content_title.doorlock_list')}</h3>
      </div>
      <div className='content-title'>
        <Filter
          columns={[
            {
              key: 'buildingId',
              type: 'select',
              size: 'xlg',
              placeholder: t('data_column.building'),
              value: filterItem.buildingId,
              action: changeFilterItem,
              selectItems: buildingListItems,
              selectItemKey: 'name',
              selectItemValue: 'id',
              isRemoveButton: true,
            },
            {
              key: 'floorId',
              type: 'select',
              size: 'md',
              placeholder: t('data_column.floor'),
              value: filterItem.floorId,
              action: changeFilterItem,
              selectItems: floorListItems,
              selectItemKey: 'name',
              selectItemValue: 'id',
              isRemoveButton: true,
            },
            {
              key: 'name',
              size: 'md',
              placeholder: t('data_column.doorlock_name'),
              value: filterItem.name,
              action: changeFilterItem,
            },
            {
              key: 'serial',
              size: 'md',
              placeholder: t('data_column.doorlock_serial'),
              value: filterItem.serial,
              action: changeFilterItem,
            },
            {
              key: 'type',
              type: 'select',
              size: 'xlg',
              placeholder: t('data_column.type'),
              value: filterItem.type,
              action: changeFilterItem,
              selectItems: doorlockTypeItems,
              selectItemKey: 'key',
              selectItemValue: 'value',
              isRemoveButton: true,
            },
            {
              key: 'status',
              type: 'select',
              size: 'lg',
              placeholder: t('data_column.status'),
              value: filterItem.status,
              action: changeFilterItem,
              selectItems: statusItems,
              selectItemKey: 'key',
              selectItemValue: 'value',
              isRemoveButton: true,
            },
            {
              key: 'fwType',
              type: 'select',
              size: 'md',
              placeholder: t('data_column.fw_type'),
              value: filterItem.fwType,
              action: changeFilterItem,
              selectItems: doorlockFormatter.fwTypeItems,
              selectItemKey: 'key',
              selectItemValue: 'value',
              isRemoveButton: true,
            },
            {
              key: 'fwVersion',
              size: 'xsm',
              placeholder: t('data_column.fw_version'),
              value: filterItem.fwVersion,
              action: changeFilterItem,
            },
          ]}
          init={initFilterItem}
        />
      </div>
      <Table
        columns={[
          {
            key: 'view',
            text: t('data_column.view'),
            width: '8%',
            moveToPage: {
              func: (doorlockId) => history.push(`/doorlock/${doorlockId}`),
              params: ['id'],
            },
          },
          {
            key: 'name',
            text: t('data_column.doorlock_name'),
            width: '11%',
            sort: {
              func: changeSort,
              params: 'name',
              selected: sortItem.sort === 'name',
              order: sortItem.sort === 'name' ? sortItem.order : 'desc',
            },
          },
          {
            key: 'type',
            text: t('data_column.type'),
            width: '8%',
            formatter: {
              func: doorlockTypeFormatter,
              params: ['type'],
            },
          },
          {
            key: 'dl_serial',
            text: t('data_column.doorlock_serial'),
            width: '8%',
          },
          {
            key: 'building_name',
            text: t('data_column.building'),
            width: '13%',
            // linker: {
            //   func: (buildingId) => history.push(`/building/${buildingId}`),
            //   params: ['building_id'],
            // },
            sort: {
              func: changeSort,
              params: 'building_name',
              selected: sortItem.sort === 'building_name',
              order: sortItem.sort === 'building_name' ? sortItem.order : 'desc',
            },
          },
          {
            key: 'floor_name',
            text: t('data_column.floor'),
            width: '7%',
            // linker: {
            //   func: (floorId) => history.push(`/floor/${floorId}`),
            //   params: ['floor_id'],
            // },
            sort: {
              func: changeSort,
              params: 'floor_name',
              selected: sortItem.sort === 'floor_name',
              order: sortItem.sort === 'floor_name' ? sortItem.order : 'desc',
            },
          },
          {
            key: 'status',
            text: t('data_column.status'),
            width: '8%',
            formatter: {
              func: doorlockStatusFormatter,
              params: ['status'],
            },
            sort: {
              func: changeSort,
              params: 'status',
              selected: sortItem.sort === 'status',
              order: sortItem.sort === 'status' ? sortItem.order : 'desc',
            },
          },
          {
            key: 'fw_type',
            text: t('data_column.fw_type'),
            width: '10%',
            formatter: {
              func: doorlockFormatter.fwType,
              params: ['fw_type'],
            },
          },
          {
            key: 'fw_version',
            text: t('data_column.fw_version'),
            width: '7%',
          },
          {
            key: 'fw_battery',
            text: t('data_column.battery_status'),
            width: '8%',
            formatter: {
              func: doorlockBatteryFormatter,
              params: ['fw_battery'],
            },
            sort: {
              func: changeSort,
              params: 'fw_battery',
              selected: sortItem.sort === 'fw_battery',
              order: sortItem.sort === 'fw_battery' ? sortItem.order : 'desc',
            },
          },
          {
            key: 'created_at',
            text: t('data_column.created_at'),
            width: '12%',
            formatter: {
              func: dateFormatter,
              params: ['created_at'],
            },
            sort: {
              func: changeSort,
              params: 'created_at',
              selected: sortItem.sort === 'created_at',
              order: sortItem.sort === 'created_at' ? sortItem.order : 'desc',
            },
          },
          {
            key: 'button',
            text: '',
            width: '5%',
            items: [
              {
                text: t('button.doorlock_uninstall'),
                disabled: {
                  func: (status) => status !== 'installed' || !doorlockDeletable,
                  params: ['status'],
                },
                action: {
                  func: selectDoorlockUninstall,
                  params: ['id', 'status', 'name'],
                },
              },
            ],
          },
        ]}
        datas={doorlockListItems}
      />
      <LimitButton
        currentLimit={paginationItem.limit}
        changeLimit={changeLimit}
      />
      <Pagination
        total={doorlockListTotal}
        index={currentPageNumber}
        limit={paginationItem.limit}
        indexChange={changePagination}
      />
      <DoorlockUninstall
        isOpen={isOpenDoorlockUninstallModal}
        toggle={() => setIsOpenDoorlockUninstallModal(!isOpenDoorlockUninstallModal)}
        reload={() => listDoorlockApi()}
        doorlockId={selectedDoorlockId}
        doorlockName={selectedDoorlockName}
      />
    </Fragment>
  );
};

export default DoorlockList;